import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { RadioGroup as RadioGroupNext, Radio as RadioNext} from "@nextui-org/react";
import { TextNT } from './text';
import { Controller } from "react-hook-form";

const RadioGroup = props => {
  const { name = '', options = [], control = null, method = 'weglot', translate = true, ...rest } = props;
  const [translatedOptions, setTranslatedOptions] = useState(options);
  const currentLanguage = typeof window !== 'undefined' && window.Weglot ? window.Weglot.getCurrentLang() : null;

  useEffect(() => {
    if (currentLanguage && translate && method === 'weglot' && typeof window !== 'undefined' && window.Weglot && options.length > 0) {
      // Prepare words array for Weglot
      const words = options.map(option => ({ "t": 1, "w": option.label }));
      
      window.Weglot.translate(
        {
          'words': words,
          'languageTo': currentLanguage
        },
        function(data) {
          if (data && data.length > 0) {
            // Map translated data back to options
            const translated = options.map((option, index) => ({
              ...option,
              label: data[index] || option.label
            }));
            setTranslatedOptions(translated);
          }
        }
      );
    } else if (!translate || method === 'i18next') {
      // If not translating with Weglot, use original options
      setTranslatedOptions(options);
    }
  }, [options, translate, method, currentLanguage, name]);

  return (
    <>
      {control ? (
        <Controller
          name={name}
          control={control}
          render={({ field: { onChange, value } }) => (
            <RadioGroupNext
              orientation="horizontal"
              value={value}
              onValueChange={onChange}
              {...rest}
            >
              {translatedOptions.length > 0 && translatedOptions.map((option) => (
                <RadioNext key={option.value} value={option.value}>
                  <TextNT type='label' className='text-gray-600 text-base ml-2 font-semibold'>
                    {option.label}
                  </TextNT>
                </RadioNext>))}
            </RadioGroupNext>

          )}
        />
      ) : (
        <RadioGroupNext
          orientation="horizontal"
          {...rest}
        >
          {translatedOptions.length > 0 && translatedOptions.map((option) => (<RadioNext key={option.value} value={option.value}><TextNT type='label' className='text-gray-600 text-base font-semibold'>{option.label}</TextNT></RadioNext>))}
        </RadioGroupNext>
      )}
    </>
  );
};

RadioGroup.propTypes = {
  name: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.any.isRequired,
    label: PropTypes.string.isRequired,
  })),
  control: PropTypes.object,
  method: PropTypes.oneOf(['weglot', 'i18next']),
  translate: PropTypes.bool,
};

export default RadioGroup;
